var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"relative h-6 rounded bg-orange-200"},[_c('div',{staticClass:"absolute w-full text-center font-bold text-m z-10"},[_vm._v(_vm._s(_vm.completed)+"%")]),_c('div',{staticClass:"absolute top-0 h-6 rounded transition-duration-250",class:_vm.gradientColor,style:({width: `${_vm.completed}%`})})])
}
var staticRenderFns = []

export { render, staticRenderFns }